window.messages = {
    en : {
        message : {
            todas : 'All',
            deseasReenviar : 'Do you want to re-send this EDI?',
            locacion : 'Location',
            remarksSalida : 'Remarks',
            estimado : 'Estimated',
            reparado : 'Repaired',
            dispatched : 'Dispatched',
            aprobado : 'Approved',
            digitado : 'Typed',
            gate_in : 'Gate IN',
            despachados : 'Dispatched',
            conductorOut : 'Driver OUT',
            placaOut : 'License plate OUT',
            consulta : 'Type your search...',
            buscar : 'Search',
            seleccionarTodos : 'Select all',
            crear : 'Create',
            estado : 'Status',
            activos : 'Active',
            inactivos : 'Inactive',
            todos : 'All',
            fecha : 'Date',
            hoy : 'Today',
            ayer : 'Yesterday',
            personalizada : 'Customized',
            desde : 'From',
            hasta : 'To',
            registrosPorPagina : 'Rows by page',
            sinDatos : 'No data',
            paginas : 'Pages',
            anterior : 'Previous',
            siguiente : 'Next',
            de : 'of',
            consultaContenedores : 'Consultation of containers',
            descargarTodo : 'Download all',
            copiarLinks : 'Copy links',
            enviarEir : 'Send EIR to mail',
            contenedor : 'Container',
            patio : 'Yard',
            cliente : 'Customer',
            informacionContenedor : 'Container\'s information',
            eirCaja : 'EIR Box',
            eirMaquina : 'EIR Machine',
            usuario : 'User',
            conductor : 'Driver IN',
            fechaIngreso : 'Date in',
            placa : 'License plate IN',
            fecha : 'Date',
            observacion : 'Observation',
            firmaConductor : 'Driver\'s signature IN',
            firmaInspector : 'Inspector\'s signature IN',
            firmaSupervisorInsp : 'Inspection supervisor signature',
            firmaSupEstCaja : 'Estimate supervisor signature (Box)',
            firmaSupEstMaq : 'Estimate supervisor signature (Machine)',
            firmaSupRep : 'Reparation supervisor signature',
            firmaSupSal : 'Thecnical signature OUT',
            inspeccion : 'Inspection',
            estimacion : 'Estimate',
            reparacion : 'Reparation',
            salida : 'Departure',
            observaciones : 'Remarks',
            sinDatos : 'No data',
            errorText : 'There was an error, try again.',
            error : 'Error',
            enviarCorreo : 'Send E-mail',
            cancelar : 'Cancel',
            email : 'E-mail (Separated by commas)',
            placeholderCorreo : 'example@domain.com,example2@domain.com',
            correoEnviado : 'The mail was sent successfully.',
            aviso : 'Advice',
            errorValidacion : 'Validation error',
            inspeccionados : 'Inspected',
            estimados : 'Estimated',
            reparados : 'Repaired',
            tipoFecha : 'Date type',
            customDate : 'Custom dates',
            filterContainer : 'Filter by container\'s number',
            numeroContenedor : 'Container\'s number',
            garita : 'Garita',
            caja : 'Box',
            maquina : 'Machine',
            deseasDesbloquear : 'Do you want to unlock this record?',
            confirmar : 'Confirm',
            accionRealizada : 'The action was done successfuly.',
            localizaciones : 'Machine locations',
            exportar : 'Export',
            activar : 'enable',
            desactivar : 'disable',
            deseas : 'Do you want to',
            esteRegistro : 'this record',
            requiereConfirmacion : 'This action requires confirmation.',
            emailRequerido : 'The e-mail is required.',
            elRegistro : 'The record has been',
            activado : 'enabled',
            desactivado : 'disabled',
            codigo : 'Code',
            descripcion : 'Description',
            linea : 'Line',
            creacion : 'Created at',
            modificacion : 'Updated at',
            localizacion : 'Machine location',
            tipo : 'Type',
            guardar : 'Save',
            saved : 'The record has been stored.',
            partes : 'Parts',
            valor : 'Value',
            horas_hombre : 'Man hours',
            noPuedeEliminar : 'You cannot delete this record, it has depending records.',
            parte : 'Part',
            modos : 'Modes',
            modo : 'Mode',
            remarks : 'Machine remarks',
            remark : 'Machine remark',
            damage : 'Damage',
            damages : 'Damages',
            siglas : 'Acronym',
            tipo_unidad : 'Unit type',
            piezas : 'Pieces',
            tiposModelo : 'Model types',
            creador : 'Creator',
            modificador : 'Updater',
            filtros : 'Filters',
            sts : 'STS',
            busquedaGeneral : 'General search',
            importar : 'Import',
            lineas : 'Lines',
            todasLineas : 'Apply to all lines',
            tipoContenedor : 'Container type',
            parche : 'Patch',
            tipoValoracion : 'Assessment type',
            siglasComa : 'Acronym (Separated by comma)',
            tipos : 'Types',
            valoracionArea : 'Assessment by perimeter',
            nuevo : 'New',
            deseasCrear : 'Do you want to create a new record?',
            formularioLimpiado : 'The form data will be cleared',
            seleccionarModo : 'You must select at least one mode.',
            constante : 'Constant',
            porcentaje : 'Percent',
            desactivar2 : 'Disable',
            activar2 : 'Enable',
            area : 'Perimeter',
            tiposUnidad : 'Unit types',
            tpi : 'TPI',
            firmaSupRepCaja : 'Reparation supervisor signature (Box)',
            firmaSupRepMaq : 'Reparation supervisor signature (Machine)',
            cerrar : 'Close',
            digitados : 'Digitated',
            digitado : 'Digitated',
            observacionRepC : 'Remark REP (Box)',
            observacionRepM : 'Remark REP (Machine)',
            eirCajaOut : 'EIR OUT',
            eirMaquinaOut : 'EIR Machine OUT',
            observacionRep : 'Remarks REP',
            usuarioRepC : 'User REP (Box)',
            usuarioRepM : 'User REP (Machine)',
            firmaInspOut : 'Supervisor signature OUT',
            firmaCondOut : 'Driver signatura OUT',
            observacionesRep : 'Reparation remarks',
            fechaSalida : 'OUT Date',
            observacionSalida : 'OUT Remark',
            ventila : 'Ventilate',
            temperatura : 'Temp',
            firmaInspectorMaquina : 'Inspector sign EST (Machine)',
            firmaInspectorCaja : 'Inspector sign EST (Box)',
            consultaHistorico : 'Containers history',
            secuencia : 'Sequence',
            size : 'Size',
            damageType : 'Damage type',
            booking : 'Booking',
            cantidadTotal : 'Total quantity',
            totalDespachados : 'Dispatched count',
            despachadosIN : 'Dispatched IN',
            errorBooking : 'The new dispatches cuantity must be major or equal than the dispatched quantity and minor or equal than total quantity of booking.',
            despachosRequeridos : 'The dispatch quantity is required.',
            containers : 'Containers',
            informacionConsulta : 'Search information',
            resultados : 'Results',
            mostrar_mas : 'Show more...',
            despachado : 'Despachado',
            bookingActualizado : 'The booking has been updated.',
            enviado : 'Sent',
            notificacion : 'Notification'
        }
    },
    es : {
        message : {
            lineas : 'Líneas',
            todas : 'Todas',
            notificacion : 'Notificación',
            enviado : 'Enviado',
            locacion : 'Localización',
            remarksSalida : 'Observaciones',
            estimado : 'Estimado',
            reparado : 'Reparado',
            dispatched : 'Despachado',
            aprobado : 'Aprobado',
            digitado : 'Digitado',
            bookingActualizado : 'El booking ha sido actualizado.',
            mostrar_mas : 'Mostrar más...',
            resultados : 'Resultados de la consulta',
            informacionConsulta : 'Información de la consulta',
            containers : 'Contenedores',
            despachosRequeridos : 'La cantidad de despachos es requerida.',
            errorBooking : 'La cantidad de despachos nueva debe ser mayor o igual a la cantidad despachada y menor o igual a la cantidad total del booking.',
            despachadosIN : 'Despachados IN',
            totalDespachados : 'Total despachados',
            cantidadTotal : 'Cantidad total',
            booking : 'Booking',
            damageType : 'Tipo de daño',
            size : 'Size',
            secuencia : 'Secuencia',
            consultaHistorico : 'Histórico de contenedores',
            firmaInspectorCaja : 'F. Inspector EST (Caja)',
            firmaInspectorMaquina : 'F. Inspector EST (Máquina)',
            temperatura : 'Temp',
            ventila : 'Ventila',
            observacionSalida : 'Obs. Salida',
            fechaSalida : 'Fecha de salida',
            observacionesRep : 'Observaciones de reparación',
            firmaCondOut : 'F. Conductor OUT',
            firmaInspOut : 'F. Supervisor OUT',
            usuarioRepC : 'Usuario REP (Caja)',
            usuarioRepM : 'Usuario REP (Máquina)',
            placaOut : 'Placa OUT',
            digitado : 'Digitado',
            digitados : 'Digitados',
            cerrar : 'Cerrar',
            firmaSupRepCaja : 'F. Supervisor REP (Caja)',
            firmaSupRepMaq : 'F. Supervisor REP (Máquina)',
            tpi : 'TPI',
            tiposUnidad : 'Tipos de unidad de medida',
            area : 'Perímetro',
            activar2 : 'Activar',
            desactivar2 : 'Desactivar',
            constante : 'Constante',
            porcentaje : 'Porcentaje',
            seleccionarModo : 'Debe seleccionar al menos un modo',
            formularioLimpiado : 'Los datos del formulario serán limpiados',
            deseasCrear : '¡Deseas crear un nuevo registro?',
            deseasReenviar : '¿Deseas re-enviar este EDI?',
            nuevo : 'Nuevo',
            valoracionArea : 'Valoración por perímetro',
            tipos : 'Tipos',
            siglasComa : 'Siglas (Separadas por coma)',
            tipoValoracion : 'Tipo de valoración',
            parche : 'Parche',
            tipoContenedor : 'Tipo de contenedor',
            todasLineas : 'Todas las líneas',
            importar : 'Importar',
            busquedaGeneral : 'Búsqueda general',
            sts : 'STS',
            filtros : 'Filtros',
            creador : 'Creador',
            modificador : 'Modificador',
            tiposModelo : 'Tipos de modelo',
            piezas : 'Piezas',
            tipo_unidad : 'Tipo de unidad de medida',
            siglas : 'Siglas',
            damages : 'Daños',
            damage : 'Daño',
            remark : 'Observación de máquina',
            remarks : 'Observaciones de máquina',
            modos : 'Modos',
            parte : 'Parte',
            noPuedeEliminar : 'No se puede eliminar este registro, ya que tiene registros dependientes del mismo.',
            valor : 'Valor',
            horas_hombre : 'Horas hombre',
            partes : 'Partes',
            saved : 'El registro ha sido almacenado.',
            guardar : 'Guardar',
            tipo : 'Tipo',
            localizacion : 'Localización de máquina',
            codigo : 'Código',
            descripcion : 'Descripción',
            linea : 'Línea',
            creacion : 'Creación',
            modificacion : 'Modificación',
            desactivado : 'desactivado',
            activado : 'activado',
            elRegistro : 'El registro ha sido',
            emailRequerido : 'El correo electrónico es requerido.',
            esteRegistro : 'este registro',
            deseas : '¿Deseas',
            activar : 'activar',
            desactivar : 'desactivar',
            exportar : 'Exportar',
            accionRealizada : 'La acción fue realizada exitósamente.',
            confirmar : 'Confirmar',
            numeroContenedor : 'Número de contenedor',
            filterContainer : 'Filtrar por número de contenedor',
            customDate : 'Fechas personalizadas',
            tipoFecha : 'Tipo de fecha',
            consulta : 'Escribe tu consulta...',
            buscar : 'Buscar',
            seleccionarTodos : 'Seleccionar todos(as)',
            crear : 'Crear',
            estado : 'Estado',
            activos : 'Activos(as)',
            inactivos : 'Inactivos(as)',
            todos : 'Todos(as)',
            fecha : 'Fecha',
            hoy : 'Hoy',
            ayer : 'Ayer',
            personalizada : 'Personalizada',
            desde : 'Desde',
            hasta : 'Hasta',
            registrosPorPagina : 'Registros por página',
            sinDatos : 'Sin datos',
            paginas : 'Páginas',
            anterior : 'Anterior',
            siguiente : 'Siguiente',
            de : 'de',
            consultaContenedores : 'Consulta de contenedores',
            descargarTodo : 'Descargar todo',
            copiarLinks : 'Copiar links',
            enviarEir : 'Enviar EIR al correo',
            contenedor : 'Contenedor',
            patio : 'Patio',
            cliente : 'Cliente',
            informacionContenedor : 'Información del contenedor',
            eirCaja : 'EIR Caja IN',
            eirMaquina : 'EIR Máquina IN',
            eirCajaOut : 'EIR OUT',
            eirMaquinaOut : 'EIR Máquina OUT',
            usuario : 'Usuario',
            conductor : 'Conductor IN',
            fechaIngreso : 'Fecha de ingreso',
            placa : 'Placa IN',
            fecha : 'Fecha',
            observacion : 'Observación',
            firmaConductor : 'F. Conductor IN',
            firmaInspector : 'F. Inspector IN',
            firmaSupervisorInsp : 'F. Supervisor INSP',
            firmaSupEstCaja : 'F. Supervisor EST (Caja)',
            firmaSupEstMaq : 'F. Supervisor EST. (Máquina)',
            firmaSupRep : 'F. Supervisor REP.',
            firmaSupSal : 'F. Técnico OUT.',
            inspeccion : 'Inspección',
            estimacion : 'Estimación',
            reparacion : 'Reparación',
            salida : 'Salida',
            observaciones : 'Observaciones',
            observacionRepC : 'Observación REP (Caja)',
            observacionRepM : 'Observación REP (Máquina)',
            observacionRep : 'Observaciones REP',
            sinDatos : 'Sin datos',
            errorText : 'Hubo un error, intente nuevamente.',
            error : 'Error',
            enviarCorreo : 'Enviar correo',
            cancelar : 'Cancelar',
            email : 'Correo electrónico (Separados por coma)',
            placeholderCorreo : 'ejemplo@dominio.com,ejemplo2@dominio.com',
            correoEnviado : 'El correo ha sido enviado exitósamente.',
            aviso : 'Aviso',
            errorValidacion : 'Error de validación',
            inspeccionados : 'Inspeccionados',
            estimados : 'Estimados',
            reparados : 'Reparados',
            garita : 'Garita',
            caja : 'Caja',
            maquina : 'Máquina',
            deseasDesbloquear : '¿Deseas desbloquear este registro?',
            localizaciones : 'Localizaciones de máquina',
            requiereConfirmacion : 'Esta acción require confirmación.',
            modo : 'Modo',
            conductorOut : 'Conductor OUT',
            gate_in : 'Gate IN',
            despachados : 'Despachados',
            despachado : 'Despachado'
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/messages.js